import React from 'react';
import PropTypes from 'prop-types';
import { Box, Button, Typography } from '@mui/material';
import { Add as AddIcon } from '@mui/icons-material';
// eslint-disable-next-line import/no-unresolved -- uuid v13 is exports-map only; the bundler resolves it fine
import { v4 as uuidv4 } from 'uuid';
import useThemeStyles from '../../../hooks/useThemeStyles';
import FormulaCard from './FormulaCard';

/**
 * List of formula cards with live evaluation.
 */
const FormulasSection = ({ formulas, onChange }) => {
  const { colors } = useThemeStyles();

  const addFormula = () => {
    onChange([
      ...formulas,
      {
        id: uuidv4(),
        name: `Formula ${formulas.length + 1}`,
        expression: '',
        description: '',
        variables: [],
      },
    ]);
  };

  const updateFormula = (index, updated) => {
    onChange(formulas.map((formula, i) => (i === index ? updated : formula)));
  };

  const deleteFormula = (index) => {
    onChange(formulas.filter((_, i) => i !== index));
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
        <Typography variant="body2" sx={{ color: colors.text.secondary }}>
          Damage curves, XP tables, drop rates — write them down and test them live.
        </Typography>
        <Button
          size="small"
          variant="outlined"
          startIcon={<AddIcon />}
          onClick={addFormula}
          sx={{ textTransform: 'none', flexShrink: 0 }}
        >
          Add Formula
        </Button>
      </Box>

      {formulas.length === 0 ? (
        <Typography variant="body2" sx={{ color: colors.text.secondary }}>
          No formulas yet.
        </Typography>
      ) : (
        <Box
          sx={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(340px, 1fr))',
            gap: 2,
          }}
        >
          {formulas.map((formula, index) => (
            <FormulaCard
              key={formula.id}
              formula={formula}
              onChange={(updated) => updateFormula(index, updated)}
              onDelete={() => deleteFormula(index)}
            />
          ))}
        </Box>
      )}
    </Box>
  );
};

FormulasSection.propTypes = {
  formulas: PropTypes.arrayOf(PropTypes.shape({})),
  onChange: PropTypes.func.isRequired,
};

FormulasSection.defaultProps = {
  formulas: [],
};

export default FormulasSection;
